<template>
    <v-layout>
      <div v-if="needInit && getLanguageIcons && user">{{initData()}}</div>
      
        <v-flex xs12 v-if="myContent!=null"> 
            <v-card class="shadow-none background-transparent">
              <v-card-text class="px-1 py-1">
                 <v-layout class="vertically-horizontally-centered">
                    <v-flex xs8 v-if="showIndex > -1">
                        <v-card class="shadow-none background-transparent">                          
                                <v-layout>
                                    <v-flex xs2 class="d-flex align-center justify-center pr-2">  
                                        <span>{{item_index}}. </span>    

                                        <span class="pl-4 d-block align-center">
                                            <img :src="getLanguageIcons[showIndex].url" width="17" class="d-block mx-auto py-2 border-b" />
                                            <v-icon class="d-block mx-auto py-2" dense>{{getTaskIcon(myContent.task_type_id)}}</v-icon>
                                            <v-icon v-if="myContent.islocked" class="d-block mx-auto py-2 border-t" color="primary" dense>lock</v-icon>
                                        </span>                          
                                    </v-flex>

                                    <!-- languages -->
                                    <v-flex xs10 class="border-l px-2">     
                                        <div @click="openTask(showIndex)" class="fill-height cursor-pointer">
                                            <p v-if="myContent.languages[showIndex].content.length > 0" v-html="myContent.languages[showIndex].content" class="fill-height editor-code-area--md-elevation-bg"></p>
                                            <p v-else style="color:orange">-- not translated  --</p>                                       
                                        </div>
                                    </v-flex>
                                </v-layout>
                        </v-card>
                    </v-flex>

                    <v-flex v-if="myContent.languages[showIndex].permissions" xs2>
                        <div class="btn-group-b ml-3">
                                <v-icon small @click="openTask(showIndex)" class="color--medium-emphasis btn-group-b__button">edit</v-icon>
                                <v-icon v-if="myContent.languages[showIndex].visible == 0" small @click="changeVisibility(showIndex)" class="color--medium-emphasis btn-group-b__button">visibility_off</v-icon>      
                                <v-icon v-else small @click="changeVisibility(showIndex)" class="color--medium-emphasis btn-group-b__button">visibility</v-icon>
                        </div>
                    </v-flex>


                    <v-flex xs3 class="language__translator-group vertically-horizontally-centered" data-title="translated (click to show)">
                        <span v-for="(language,index) in myContent.languages" :key=index class="translator-group__item">
                            <img v-if="language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.lang_id-1].url"
                            :title='getLanguageIcons[language.lang_id-1].title'  @click ="showIndex = index"
                            />
                        </span>    
                    </v-flex>
                    <v-flex xs3 class="language__translator-group vertically-horizontally-centered" data-title="not translated (click to edit)">
                        <span v-for="(language,index) in myContent.languages" :key=index class="translator-group__item">
                            <img v-if="!language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.lang_id-1].url"
                            :title='getLanguageIcons[language.lang_id-1].title' @click ="openTask(index)"
                            :style="getCursorPermission(index)"
                            />
                        </span>  
                    </v-flex> 
                 </v-layout>
            </v-card-text>   
          </v-card>
      </v-flex>
    
  </v-layout>
</template>

<script>
import axios from '../../../axios-auth.js'
import {mapGetters} from 'vuex'
import * as icn from '../../../assets/task_icons.js'

  export default {
    data() {
      return {
        needInit : false,
        myContent : null,
        showIndex : -1,
        systemPermissions : null,
      }
    },
    props: { 
        my_element: Object, 
        permissions : Array,
        lang_index : String,
        brc: Object,
        item_index: Number
    },    
    watch: { 
        lang_index: function(newVal, oldVal) { // watch it
          if(oldVal != newVal)
            this.showIndex = newVal
        },
    },
    computed: 
        mapGetters([
                        'getLanguageIcons',
                        'user'
                    ])
    ,
    mounted() {
        this.needInit = true
    },
   methods: {
    initData() {
        this.needInit = false  
        this.$store.commit('setFeedback', null)
        this.systemPermissions = this.$store.getters.getSystemPermissions
        this.prepareContent(this.my_element)
        this.showIndex = parseInt(this.lang_index)        
    },
    prepareContent(_element) {
        // console.log(_element)

        this.myContent = {
            id : this.my_element.id,
            task_type_id:this.my_element.task_type_id,
            order: this.my_element.task_order,
            islocked: this.my_element.islocked,
            lck_user: this.my_element.lck_user,
            locked: this.my_element.locked,
            max_score: this.my_element.max_score,
            languages : []      
        }
        var j = 0
        for(let i = 0; i < this.getLanguageIcons.length; i++) {
            if (j >= _element.translations.length || _element.translations[j].lang_id != this.getLanguageIcons[i].id) {
                this.myContent.languages.push( {
                    lang_id: this.getLanguageIcons[i].id,
                    content: '',
                    visible: 1,
                    translated: false,
                    permissions: this.getPermissions(this.getLanguageIcons[i].id, this.myContent.id)
                  }                  
                )                
            } else { // ==
                const _content = this.getContentPreview(_element.translations[j].content, this.my_element.task_type_id)
                this.myContent.languages.push( {
                    lang_id: this.getLanguageIcons[i].id,
                    content: _content,
                    visible: _element.translations[j].visible,
                    translated: _content.length > 0 ? true : false,
                    permissions: this.getPermissions(this.getLanguageIcons[i].id, this.myContent.id)
                  }
                )
                j = j + 1
            }
        }
    },
    getPermissions(_lang_id, _chapter_id) {
        // console.log(this.permissions) 
        if (this.permissions.length < 1) return false        
        for(let i = 0; i< this.permissions.length; i++) {
            if (this.permissions[i].role_code > 999) 
              return true
            if (this.permissions[i].role_code == this.systemPermissions.course_content_creator)
              return true
            if ((this.permissions[i].role_code == this.systemPermissions.course_content_translator)
               && (_lang_id == this.permissions[i].language_id))
              return true
            if ((this.permissions[i].role_code == this.systemPermissions.chapter_content_creator)
                   && (_chapter_id == this.permissions[i].sub_obj_id))
              return true
            if ((this.permissions[i].role_code == this.systemPermissions.chapter_content_translator)
                   && (_lang_id == this.permissions[i].language_id)
                   && (_chapter_id == this.permissions[i].sub_obj_id))
              return true
        }
        return false
    },
    getCursorPermission(_index) {
        if (this.myContent.languages[_index].permissions)
           return "cursor:pointer;"
        return "cursor:not-allowed;"
    },
    getContentPreview(_text,_task_type_id) {
        if (_text.length < 5) return ''
        var _data = ''
        if (_task_type_id == 1) _data = _text
         else {
            if (_task_type_id < 8) _data = JSON.parse(_text).content
            if (_task_type_id > 7 && _task_type_id < 12) _data = JSON.parse(_text).title
            if (_task_type_id == 12) try {_data = JSON.parse(_text)[0].source[0] } catch(e) {_data="Jupiter style content"}
            if (_task_type_id > 12 && _task_type_id <= 15) try {_data = JSON.parse(_text).content[0].source[0] } catch(e) {_data="Jupiter style tasks"}            
            if (_task_type_id == 16 || _task_type_id == 17) try {_data = JSON.parse(_text)[0].source[0] } catch(e) {_data="Jupiter style tasks"}            
        }
        let start = _data.indexOf("<p>")
        var end = _data.indexOf(" ", start + 200)
        if (end < 1) end = start + 200
        _data = _data.substring(start, end)
        if (_data.length < end) end = _data.length
        if (_data.substring(end-4) == "</p>")
         _data = _data.substring(0,end-5) + " ...</p>"
        return _data
    },
    // saving via axios
    changeVisibility(_index) {
        this.myContent.languages[_index].visible = 1-this.myContent.languages[_index].visible
        const _data = {
            task_id: this.myContent.id,
            visibility: this.myContent.languages[_index].visible,
            lang_id: _index + 1,
        }
        axios.post('/change-task-visibility', _data, this.$store.getters.getAxiosConfig)
        .then(res => {
            if (res.data.message != 'OK') {
                this.$store.commit('setFeedback', res.data.message)
                return
            }                 
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })                         
    },
    clearTranslation(_index) { 
        if (!this.myContent.languages[_index].translated) return
        this.myContent.languages[_index].name = ''
        this.myContent.languages[_index].translated = false
        this.finalSave(_index, 1)
    },
    getTaskIcon(index) {
      return icn.getTaskIcon(index)
    },
    openTask(_index) {
        // let _index2 = _index == this.showIndex ? _index: this.showIndex
        this.$router.push({name:'task_edit', params: {
            id_type: this.my_element.task_type_id, show_lang: this.showIndex > -1 ? this.showIndex : _index, 
            edit_lang: _index, id: this.my_element.id,
            course_id: this.brc.course.id, lesson_id: this.brc.lesson.id
            }})
    }
   }
  }
  </script>